import { render, staticRenderFns } from "./PowerBiReport.vue?vue&type=template&id=5f5c49cb&"
import script from "./PowerBiReport.vue?vue&type=script&lang=ts&"
export * from "./PowerBiReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports